<tc-lead-passenger-selection class="lead-passenger-selection"
        [passengers]="passengers"
        [isCompleted] = "isCompleted"
        [leadPassenger]="leadPassenger"
        (save)="onSaveLeadPassenger($event)"
        (closePopUp)="onClosePopup($event)">

</tc-lead-passenger-selection>
